import React, { Component } from 'react';
import { ComboBox, Alert} from '../../../js/ComponentManager'
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:계좌번호관리
 * 세부설명:
*/

export class AccountNumber extends Component {
    static displayName = AccountNumber.name;

    constructor(props) {
        super(props);
        this.state = {
            BankList: [],
            Bank_Cd: "",
            Acct_Hodr: "",
            Acct_No: "",
            RegisterSuccess: false,    //수정 완료
            Content: ""
        };
        this.handleChange = this.handleChange.bind(this);
        this.handle_Save = this.handle_Save.bind(this);
    }
    //초기화
    async componentDidMount() {
        await this.BankCodeDataCall();
        await this.CallAccountNumber();
    }
    handleChange(event) {
        let tagId = event.target.id;
        let value = event.target.value.trim();
        this.setState({ [tagId]: value });
        return false;
    }
    async CallAccountNumber() {
        try {
            
            let Data = await Big3Common.Get('api/MyPage/MyInfoMgr/GetAccountnoMgr');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let list = JSON.parse(Data.dataTable);
                if (list.length > 0) {
                    this.setState({
                        Bank_Cd: list[0]["bank_cd"],
                        Acct_Hodr: list[0]["acct_hodr"],
                        Acct_No: list[0]["acct_no"]
                    });
                }
            }
            else {
                console.log(Data.message);
            }
        }
        catch (e) {
            console.log("CallAccountNumber: ", e)
        }
        return false;
    }
    async BankCodeDataCall() {
        try {
            //은행코드 017
            const MstCd = "017";
            let Data = await Big3Common.Get(`api/Common/BaseCode/GetCommonCode/${MstCd}`);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                let BankList = JSON.parse(Data.dataTable);
                if (BankList.length > 0) {
                    this.setState({ BankList: BankList });
                }
            }
            else {
                console.log("등록된 코드가 없습니다.");
            }
        }
        catch (e) {
            console.log("BankCodeDataCall: ", e)
        }
        return false;
    }
    async handle_Save() {

        let isOk = false;
        if (this.state.Bank_Cd.trim().length === 0) {
            this.setState({ Content: "은행을 선택하여주세요." });
        }
        else if (this.state.Acct_Hodr.trim().length === 0) {
            this.setState({ Content: "예금주를 입력하여주세요." });
        }
        else if (this.state.Acct_No.trim().length === 0) {
            this.setState({ Content: "계좌번호를 입력하여주세요." });
        }
        else {
            isOk = true;
        }
        if (!isOk) {
            Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            return false;
        }
        else {
            try {
                let data = await Big3Common.Post("api/MyPage/MyInfoMgr/RegisterAccountnoMgr", {
                    Bank_Cd: this.state.Bank_Cd,
                    Acct_Hodr: this.state.Acct_Hodr,
                    Acct_No: this.state.Acct_No
                }, true);

                this.setState({ Content: data.message, RegisterSuccess:true });
                Big3Common.ModalAlert(bootstrap, 'MessageAlert');
            }
            catch (e) {
                console.log("handle_Save: ", e);
            }
        }
    }
    render() {
        return (
            <div>
                <div className="container_box p_margin c_padding">
                    <div className="account_manage_title">계좌번호등록 하기</div>
                    <div className="select_bank_box">
                        <ComboBox id="Bank_Cd"
                            ComboChange={this.handleChange}
                            emptyText="은행선택"
                            textName="dtl_nm"
                            valueName="dtl_cd"
                            setValue={this.state.Bank_Cd}
                            optionList={this.state.BankList}
                        />
                    </div>
                    <div className="select_bank_box input_line">
                        <input type="text"
                            id="Acct_Hodr"
                            className="form-control"
                            maxLength="20"
                            placeholder="예금주를 입력해주세요."
                            value={this.state.Acct_Hodr}
                            onChange={this.handleChange}
                        />
                    </div>
                    <div className="select_bank_box input_line">
                        <input type="number"
                            id="Acct_No"
                            className="form-control"
                            maxLength="20"
                            placeholder="계좌번호를 입력해주세요. (-)제외"
                            value={this.state.Acct_No}
                            onChange={this.handleChange}
                        />
                    </div>
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handle_Save} >등록하기</button>
                </div>
                <Alert
                    id="MessageAlert"
                    content={this.state.Content}
                    title="계좌정보 등록안내"
                    AlertClick={() => {
                        if (this.state.RegisterSuccess === true) {
                            this.props.RenderComponent('MyPage');
                        }
                    }}
                />
            </div>
        );
    }
}
